import styled from 'styled-components';
import Image from '@stencil/image';
import {
  BaseColumnWrap,
  ButtonBase,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const DQuickCardWrap = styled(BaseColumnWrap)(
  props => `
  max-width: 120rem;
  width: 100%;
  margin: ${props.theme.spacing.large} auto;
    `,
);
export const PreviousStayHeader = styled.div(
  props => `
    display:flex;
    width:fit-content;
    background-image: linear-gradient(to top, #f4a900, #f8cd46);
    padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
    border-top-right-radius:${props.theme.misc.borderRadius.custom(10)};
    border-top-left-radius:${props.theme.misc.borderRadius.custom(10)};
    color:${props.theme.colors.goWhite.base};
    font-weight: 600;
    font-size:${props.theme.font.custom(14)};
      `,
);
export const DBookCard = styled.div(
  props => `
    display:flex;
    width:100%;
    background: ${props.theme.colors.goWhite.base};
    padding: ${props.theme.spacing.custom(16)}  ${props.theme.spacing.custom(
      23,
    )}  ${props.theme.spacing.custom(18)}  ${props.theme.spacing.custom(12)};
    border-top-right-radius:${props.theme.misc.borderRadius.custom(12)};
    border-bottom-right-radius:${props.theme.misc.borderRadius.custom(12)};
    border-bottom-left-radius:${props.theme.misc.borderRadius.custom(12)};
      `,
);
export const QbRoomDetailWrap = styled.div(
  props => `
    display: flex;
    border-right: 1px solid #ffdfa3;
    width: 35%;
    align-items: center;
        `,
);
export const QbAmenitiesDetailWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ffdfa3;
    width: 30%;
    align-items: center;
        `,
);
export const QbPricingDetailWrap = styled.div(
  props => `
    display: flex;
    width: 35%;
    align-items: center;
    padding-left: ${props.theme.spacing.custom(100)}
    `,
);
export const RoomImage = styled(Image)(
  props => `
    width: 14rem;
    height: 10rem;
    border-radius:0.8rem;
    margin-right:${props.theme.spacing.xlarge};
    `,
);
export const RoomDetails = styled.p(
  props => `
    font-size:${props.theme.font.custom(14)};
    font-weight: 600;
    margin-bottom:${props.theme.spacing.large};
      `,
);
export const RoomDescriptionWrapper = styled.ul(
  props => `
        display:flex;
        flex-direction: column;
        margin-bottom:${props.theme.spacing.base};
        margin-top:${props.theme.spacing.base};
        li{
          display:flex;
          align-items: center;
          margin-bottom:${props.theme.spacing.custom(8)};
          &:last-child{
              margin-bottom:0;
            }
          >div{
            padding: 0px 1px;
          }
        }
        `,
);
export const RoomPlanTag = styled.p(
  props => `
      border-radius: 19px;
      background-image: linear-gradient(to top, #1149f3, #00c3ff);
      width:fit-content;
      padding: ${props.theme.spacing.custom(2)} ${props.theme.spacing.custom(7)};
      color: ${props.theme.colors.goWhite.base};
      margin-bottom:${props.theme.spacing.base};
      margin-right:${props.theme.spacing.custom(23)};
      font-weight: 600;
        `,
);
export const StrickedPrice = styled.p(
  props => `
      text-decoration: line-through;
      color: #777777;
      
  `,
);
export const OriginalPricePrice = styled.p(
  props => `
    font-weight: 600;
    font-size: ${props.theme.font.custom(22)};
   
  `,
);
export const TaxFeePara = styled.p(
  props => `
    color: #777777;
    font-size: ${props.theme.font.custom(10)}
  `,
);
export const QuickBookBtn = styled(ButtonBase)(
  props => `
    display:flex;
    padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(8)};
    height:4.2rem;
      font-size: ${props.theme.font.custom(16)};
    text-transform: none;
    width:65%;
  `,
);

export const RoomOptionsIconContainer = styled.div(
  props => `
  padding: 0 ${props.theme.spacing.base} 0 0;
`,
);

export const CancellationPolicyContainer = styled.div`
  display: flex;
  flex-direction: column;
  span {
    font-size: 1.2rem;
  }
`;
